module.exports = __webpack_public_path__ + "img/quad-water-sm.21a5462e.svg";